module.exports = __webpack_public_path__ + "img/icon-ekyc-detail-finger-print.06b2bed.svg";